module.exports = __webpack_public_path__ + "img/4.abd52979.png";